import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import {StyledGridCol, StyledGridRow} from "@/common/styles";
import TextField from "@/common/elements/InputElements/TextField";
import {BookingsSectionTitle} from "../styles";
import CommonDatePicker from "@/common/elements/DatePicker";
import {getOptionsFromRefList, isNonEmptyVariable} from "@/util/common_function";
import {Form, Input, InputNumber} from "antd";
import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const BookingHoldsForm = forwardRef(({selectedHold, holdFormRef}) => {
    const [holdForm] = Form.useForm();
    const [formData, setFormData] = useState(null);
    const [holdStatusType, setHoldStatusType] = useState(52180003)
    const [filterCharge, setFilterCharge] = useState(52180003)
    const fullSearch = useSelector(state => state.fullSearch);
    useEffect(() => {
        setFormData(() => ({
            ...selectedHold,
            holdReason: selectedHold?.holdReason ? parseInt(selectedHold?.holdReason) : null,
            holdStatus: selectedHold?.holdStatus ? parseInt(selectedHold?.holdStatus) : fullSearch ? null : 52180003,
            chargeDescriptionId: selectedHold?.chargeDescriptionId ? parseInt(selectedHold?.chargeDescriptionId) : null,
            expiresDateTime: isNonEmptyVariable(selectedHold?.expiresDate) ? dayjs(`${selectedHold.expiresDate} ${selectedHold.expiresTime}`) : null,
            clearanceAuthorizationDateTime: isNonEmptyVariable(selectedHold?.ClearanceAuthorizationDate) ? dayjs(`${selectedHold?.ClearanceAuthorizationDate} ${selectedHold?.clearanceAuthorizationTime}`) : null,
            transferAuthorizationDateTime: isNonEmptyVariable(selectedHold?.transferAuthorizationDate) ? dayjs(`${selectedHold?.transferAuthorizationDate} ${selectedHold?.transferAuthorizationTime}`) : null,
            transferDateTime: isNonEmptyVariable(selectedHold?.transferDate) ? dayjs(`${selectedHold?.transferDate} ${selectedHold?.transferTime}`) : null,
            transferReleaseDateTime: isNonEmptyVariable(selectedHold?.transferReleaseDate) ? dayjs(`${selectedHold?.transferReleaseDate} ${selectedHold?.transferReleaseTime}`) : null,
        }))

        setHoldStatusType(parseInt(selectedHold?.holdStatus))
    }, [selectedHold]);

    useEffect(() => {
        holdForm.setFieldsValue(formData);
    }, [formData]);

    useEffect(() => {
        holdStatusType === 52180001 && holdForm.setFieldValue('clearanceAuthorizationDateTime', dayjs(new Date()));
        holdStatusType === 52180001 && holdForm.setFieldValue('expiresDateTime', dayjs(new Date()));
    }, [holdStatusType])

    useImperativeHandle(holdFormRef, () => ({
        form: holdForm
    }))
    const handleStatusTypeChange = (e) => {
        setHoldStatusType(e)
    }

    const filterChagreDd = () => {
        if(filterCharge?.target?.value) {
            holdForm.setFieldValue('chargeDescriptionId', null);
            return getOptionsFromRefList("Charges", false, false, true)?.filter(item => item?.label?.toLowerCase()?.includes(filterCharge?.target?.value?.toLowerCase()))
        } else {
            return getOptionsFromRefList("Charges", false, false, true)
        }
    }

    const handleChange = (e) => {
        const newValue = e?.target?.value.replace(/\D/g, ""); // Remove non-numeric characters
        holdForm.setFieldValue('holdContactPhone', newValue);
      };

    return (
        <>
            {/* Hold Information */}
            <BookingsSectionTitle style={{marginTop: "0"}}>
                <span>Hold Information</span>
            </BookingsSectionTitle>
            <Form
                form={holdForm}
            >
                <StyledGridRow gutter={16}>
                    <StyledGridCol span={6}>
                        <FormItem label="Hold Reason" name="holdReason">
                            <Select
                                options={getOptionsFromRefList(
                                    "Hold_Reason",
                                    false,
                                    false,
                                    true
                                )}
                                // onChange={(e) => {
                                //     setTimeout(() => document.activeElement.blur(), 0)
                                // }}
                                placeholder="Hold Reason"
                                showSearch={false}
                                variant="outlined"
                            />
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Hold For" name="holdFor">
                            <TextField/>
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Hold Contact" name="holdContact">
                            <TextField/>
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Hold Contact Phone" name="holdContactPhone">
                        <Input type="text" onChange={handleChange}/>
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Hold Status" name="holdStatus">
                            <Select
                                options={getOptionsFromRefList("Hold_Status",
                                    false,
                                    false,
                                    true)}
                                placeholder="Hold Status"
                                showSearch={false}
                                variant="outlined"
                                onChange={(e) => {
                                    // setTimeout(() => document.activeElement.blur(), 0)
                                    handleStatusTypeChange(e);
                                }}
                            />
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Expires Date & Time" name="expiresDateTime">
                            <CommonDatePicker showTime={true} placeholder={"MM/DD/YYYY HH:mm"}
                                              format="MM/DD/YYYY HH:mm"/>
                        </FormItem>
                    </StyledGridCol>
                </StyledGridRow>
                <BookingsSectionTitle>
                    <span>Charge Information</span>
                </BookingsSectionTitle>
                <StyledGridRow gutter={16}>
                    <StyledGridCol span={6}>
                        <FormItem label="Filter">
                            <TextField onChange={(e) => {
                                    setFilterCharge(e)
                            }}/>
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={12}>
                        <FormItem label="Charge" name="chargeDescriptionId">
                            <Select
                                options={filterChagreDd()}
                                placeholder="Charge"
                                showSearch={false}
                                variant="outlined"
                                // onChange={(e) => {
                                //     setTimeout(() => document.activeElement.blur(), 0)
                                // }}
                            />
                        </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={6}>
                        <FormItem label="Level" name="chargeLevelID">
                            <Select
                                options={getOptionsFromRefList(
                                    "Charge_Level",
                                    false,
                                    false,
                                    true
                                )}
                                placeholder="Level"
                                showSearch={false}
                                variant="outlined"
                                // onChange={(e) => {
                                //     setTimeout(() => document.activeElement.blur(), 0)
                                // }}
                            />
                        </FormItem>
                    </StyledGridCol>
                </StyledGridRow>
                {holdStatusType === 52180001 && (
                    <>
                        <BookingsSectionTitle>
                            <span>Clearance Information</span>
                        </BookingsSectionTitle>

                        <StyledGridRow gutter={16}>
                            <StyledGridCol span={6}>
                                <FormItem label="Clearance Officer" name="clearanceOfficerStaffId">
                                    <Select
                                        options={getOptionsFromRefList("", true)}
                                        placeholder="Clearance Officer"
                                        showSearch={false}
                                        variant="outlined"
                                        // onChange={(e) => {
                                        //     setTimeout(() => document.activeElement.blur(), 0)
                                        // }}
                                    />
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem label="Reason" name="clearanceReasonID">
                                    <Select
                                        options={getOptionsFromRefList(
                                            "Clearance_Reason",
                                            false,
                                            false,
                                            true
                                        )}
                                        placeholder="Reason"
                                        showSearch={false}
                                        variant="outlined"
                                        // onChange={(e) => {
                                        //     setTimeout(() => document.activeElement.blur(), 0)
                                        // }}
                                    />
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem
                                    label="Entered Date & Time"
                                    name="clearanceAuthorizationDateTime"
                                >
                                    <CommonDatePicker showTime={true} placeholder={"MM/DD/YYYY HH:mm"}
                                                      format="MM/DD/YYYY hh:mm"/>
                                </FormItem>
                            </StyledGridCol>
                        </StyledGridRow>
                    </>)

                }
                {holdStatusType === 52180002 && (
                    <>
                        <BookingsSectionTitle>
                            <span>Transfer Information</span>
                        </BookingsSectionTitle>

                        <StyledGridRow gutter={16}>
                            <StyledGridCol span={6}>
                                <FormItem label="Authorizing Officer" name="transferAuthorizedBy">
                                    <TextField/>
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem label="Entered By" name="transferEnteredBy">
                                    <TextField/>
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem
                                    label="Entered Date & Time"
                                    name="transferAuthorizationDateTime"
                                >
                                    <CommonDatePicker showTime={true} placeholder={"MM/DD/YYYY HH:mm"}
                                                      format="MM/DD/YYYY hh:mm"/>
                                </FormItem>
                            </StyledGridCol>
                            {/* <StyledGridCol span={6}>
            <FormItem label="Entered Time" name="transferAuthorizationTime">
              <TextField />
            </FormItem>
          </StyledGridCol> */}
                            <StyledGridCol span={6}>
                                <FormItem label="Scheduled Date & Time" name="transferDateTime">
                                    <CommonDatePicker showTime={true} placeholder={"MM/DD/YYYY HH:mm"}
                                                      format="MM/DD/YYYY hh:mm"/>
                                </FormItem>
                            </StyledGridCol>
                            {/* <StyledGridCol span={6}>
            <FormItem label="Scheduled Time" name="Transfer_Time">
              <TextField />
            </FormItem>
          </StyledGridCol> */}
                            <StyledGridCol span={6}>
                                <FormItem label="Released To" name="releasedTo">
                                    <TextField/>
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem label="Released By" name="releasedBy">
                                    <TextField/>
                                </FormItem>
                            </StyledGridCol>
                            <StyledGridCol span={6}>
                                <FormItem label="Release Date & Time" name="transferReleaseDateTime">
                                    <CommonDatePicker showTime={true} placeholder={"MM/DD/YYYY HH:mm"}
                                                      format="MM/DD/YYYY hh:mm"/>
                                </FormItem>
                            </StyledGridCol>
                            {/* <StyledGridCol span={6}>
            <FormItem label="Release Time" name="transferReleaseTime">
              <TimePicker />
            </FormItem>
          </StyledGridCol> */}
                        </StyledGridRow>
                    </>)

                }
                {/* Comments */}
                <BookingsSectionTitle>
                    <span>Comments</span>
                </BookingsSectionTitle>
                <FormItem name="comments">
                    <TextField inputType="textarea"/>
                </FormItem>
            </Form>
        </>
    );
});
export default BookingHoldsForm;
